import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { t } from "i18next";
import { getIsOnpremise } from ".";
import constants from "./constants";
import getEnv from "./getEnv";
import { replaceHostName } from "./replaceHostName";
import servicesUtils from "./servicesUtils";
import { format } from "date-fns";
var getHourAndMinute = function getHourAndMinute(date) {
  var HourMinuteSecondsFormat = "KKmmss";
  return format(date, HourMinuteSecondsFormat);
};
var preparePayload = function preparePayload(data, patientUID, patientId) {
  var _constants$GENDERS$fi, _constants$GENDERS$fi2;
  var date = new Date();
  var time = getHourAndMinute(date);
  var genderAsString = t((_constants$GENDERS$fi = (_constants$GENDERS$fi2 = constants.GENDERS.find(function (gender) {
    return gender.id === data.gender;
  })) === null || _constants$GENDERS$fi2 === void 0 ? void 0 : _constants$GENDERS$fi2.label) !== null && _constants$GENDERS$fi !== void 0 ? _constants$GENDERS$fi : "");
  var patientData = _objectSpread(_objectSpread({}, data), {}, {
    gender: genderAsString,
    patientID: patientId,
    id: patientUID,
    date: date,
    time: time,
    fullname: data.name
  });
  return patientData;
};

// this should be read from .env

var isOnpremise = getIsOnpremise();
var MWL_URL = getEnv("NEXT_PUBLIC_MWL_URL");
if (isOnpremise) {
  MWL_URL = replaceHostName(MWL_URL, "mwl");
}
var createRecord = function createRecord(patientData) {
  var url = "".concat(MWL_URL, "/patient/add");
  servicesUtils.postService(url, {
    payload: patientData
  });
};
var updateRecord = function updateRecord(data) {
  var url = "".concat(MWL_URL, "/patient/upsert");
  servicesUtils.postService(url, {
    payload: data
  });
};
var upsertRecord = function upsertRecord(isEditMode, data, patientUID, patientId) {
  if (isEditMode) {
    var date = new Date();
    var time = getHourAndMinute(date);
    updateRecord({
      id: patientId,
      date: date,
      time: time
    });
  } else if (data) {
    var patientData = preparePayload(data, patientUID, patientId);
    createRecord(patientData);
  }
};
var mwl = {
  createRecord: createRecord,
  updateRecord: updateRecord,
  upsertRecord: upsertRecord
};
export default mwl;